<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="showDialog(true)"
            style="margin-bottom: 10px"
            v-if="hasCreateAuth"
          >{{ $t("button.addBrand") }}</el-button>
          <div class="tableDiv">
            <el-table :data="tableData" stripe style="width: 100%" :empty-text="$t('desc.noData')">
              <el-table-column type="index" :label="$t('title.serialNumber')" width="60"></el-table-column>
              <el-table-column prop="brandName" :label="$t('title.brandName')"></el-table-column>
              <el-table-column prop="brandCode" :label="$t('title.brandCode')"></el-table-column>
              <el-table-column :label="$t('title.operate')" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    icon="el-icon-edit"
                    :title="$t('button.update')"
                    circle
                    size="mini"
                    v-if="hasUpdateAuth"
                    @click="showEditDialog(true,scope.row)"
                  ></el-button>
                  <template v-if="hasDeleteAuth">
                    <el-popconfirm
                      placement="top"
                      :confirmButtonText="$t('button.delete')"
                      :cancelButtonText="$t('button.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('title.confirmDelete')"
                      @confirm="delRow(scope.$index, scope.row)"
                    >
                      <el-button
                        type="danger"
                        :title="$t('button.delete')"
                        icon="el-icon-delete"
                        circle
                        size="mini"
                        slot="reference"
                      ></el-button>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
    <DialogBrand
      ref="addRef"
      :dialogAddClient="dialogAdd"
      :formRef="'brandAddRef'"
      :title="(dialogTitle = $t('button.addBrand'))"
      :brandform="brandform"
      :subButtonAuth="hasCreateAuth"
      type="add"
      @dialogVisibleEvent="showDialog"
      @onSubBtn="addBrand"
    ></DialogBrand>
    <DialogBrand
      ref="editRef"
      :dialogAddClient="dialogEdit"
      :formRef="'brandEditRef'"
      :title="(dialogTitle = $t('button.editBrand'))"
      :brandform="brandform"
      :subButtonAuth="hasUpdateAuth"
      type="edit"
      @dialogVisibleEvent="showEditDialog"
      @onSubBtn="updateBrand"
    ></DialogBrand>
  </div>
</template>

<script>
import {
  getBrandInfosNoAcess,
  deleteBrand,
  creatBrand,
  updateBrand,
  authOperationCheck
} from "../../api/api";
import { mapState } from "vuex";
import DialogBrand from "../../components/content/brand/DialogBrand";
export default {
  name: "index",
  components: {
    DialogBrand
  },
  computed: mapState({
    isCollapse: state => state.isCollapse
  }),
  data() {
    return {
      dialogAdd: false,
      dialogEdit: false,
      brandform: {
        brandCode: "",
        brandName: ""
      },
      tableData: []
    };
  },
  created() {
    this.authOperation("Brand");
  },
  async mounted() {
    this.getBrandInfos();
  },
  methods: {
    authOperation(curPage) {
      var that = this;
      var res = authOperationCheck(curPage);
      that.hasCreateAuth = res.hasCreateAuth;
      that.hasUpdateAuth = res.hasUpdateAuth;
      that.hasDeleteAuth = res.hasDeleteAuth;
      // that.hasExportAuth = res.hasExportAuth;
    },
    showDialog(visible) {
      this.dialogAdd = visible;
      //每次打开dialog清楚表格数据
      this.brandform = new Object();
      if (visible) {
        //打开窗口前重置验证
        if (this.$refs.addRef.$refs.brandAddRef != undefined) {
          this.$refs.addRef.$refs.brandAddRef.resetFields();
        }
      }
    },
    showEditDialog(visible, row) {
      this.dialogEdit = visible;
      //每次打开dialog清楚表格数据
      if (visible) {
        this.brandform = {
          brandName: row.brandName,
          brandCode: row.brandCode
        };
        //打开窗口前重置验证
        if (this.$refs.editRef.$refs.brandEditRef != undefined) {
          this.$refs.editRef.$refs.brandEditRef.resetFields();
        }
      } else {
        this.brandform = new Object();
      }
    },
    async getBrandInfos() {
      let that = this;
      let res = await getBrandInfosNoAcess();
      that.tableData = res.result;
    },

    async addBrand() {
      let that = this;
      let postData = {
        BrandName: that.brandform.brandName,
        BrandCode: that.brandform.brandCode
      };
      try {
        let res = await creatBrand(postData);
        that.$message({
          showClose: true,
          message: that.$t("tips.saveSuccess"),
          type: "success"
        });
        that.showDialog(false);
        await this.getBrandInfos();
      } catch (error) {
        if (error != undefined) {
          that.$message({
            showClose: true,
            message: error.error.message,
            type: "error"
          });
        }
      }
    },
    async updateBrand() {
      let that = this;
      let postData = {
        BrandName: that.brandform.brandName,
        BrandCode: that.brandform.brandCode
      };
      try {
        let res = await updateBrand(postData);
        that.$message({
          showClose: true,
          message: that.$t("tips.updateSuccess"),
          type: "success"
        });
        that.showEditDialog(false);
        await this.getBrandInfos();
      } catch (error) {
        if (error != undefined) {
          that.$message({
            showClose: true,
            message: error.error.message,
            type: "error"
          });
        }
      }
    },
    async delRow(index, row) {
      let that = this;
      try {
        let res = await deleteBrand(row.brandCode);
        that.tableData.splice(index, 1);
        that.$message({
          showClose: true,
          message: this.$t("tips.deleteSuccess"),
          type: "success"
        });
      } catch (error) {
        console.log(error)
        if (error != undefined) {
          that.$message({
            showClose: true,
            message: error.error.message,
            type: "error"
          });
        }
      }
    }
  }
};
</script>

<style>
</style>
